import {css} from '../utils.js';

const themedStyles = css`
    .ddk-container .VirtualizedSelectFocusedOption {
        background-color: ${props => props.theme.background_content};
    }
`;
export default themedStyles;
